import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Button } from '../../../components/ui/button';
import { Save } from 'lucide-react';

export function ServiceAreaSettings({ data, setData, isSaving, onSave }) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <h3 className="font-bold text-slate-900 font-[Poppins] mb-2">Service Area Configuration</h3>
      <p className="text-sm text-slate-500 mb-6">Configure the maximum service radius that providers can set.</p>
      
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <Label>Maximum Radius (km)</Label>
          <Input
            type="number"
            value={data.max_radius_km}
            onChange={(e) => setData(prev => ({ ...prev, max_radius_km: Number(e.target.value) }))}
            className="h-12 mt-1.5"
            data-testid="max-radius-input"
          />
          <p className="text-xs text-slate-500 mt-1">Maximum distance a provider can set for their service area</p>
        </div>
        <div>
          <Label>Default Radius (km)</Label>
          <Input
            type="number"
            value={data.default_radius_km}
            onChange={(e) => setData(prev => ({ ...prev, default_radius_km: Number(e.target.value) }))}
            className="h-12 mt-1.5"
            data-testid="default-radius-input"
          />
          <p className="text-xs text-slate-500 mt-1">Default radius for new providers</p>
        </div>
      </div>
      
      <Button 
        onClick={onSave}
        disabled={isSaving}
        className="mt-6 bg-slate-900 hover:bg-slate-800"
        data-testid="save-service-area-btn"
      >
        <Save className="w-4 h-4 mr-2" />
        {isSaving ? 'Saving...' : 'Save Service Area Config'}
      </Button>
    </div>
  );
}
